export const base_url = process.env.REACT_APP_BASE_URL;
export const base_url_completa = process.env.REACT_APP_BASE_URL_COMPLETA;

    var urlencode="";
    if(base_url_completa){
        urlencode=encodeURIComponent(base_url_completa)
        //console.log(encodeURIComponent(urlencode+'/hola/2'))
    }
export const base_url_completa_codificada = urlencode;
export const base_pdf = process.env.REACT_APP_PATH_PDF;


// Navegadores

export const MENU = "menu";
export const SUBMENU = "submenu" 